import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `apache_tomcat`,

  name: {
    [LOCALES.EN_US]: `Apache Tomcat`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.runtime_environment, TYPES.platform],

  tags: [],
} as const satisfies TTerm
